import { z } from "zod";

export const editAgentSchema = z.object({
  name: z.string().trim().min(1, { message: "Name is required" }),
  description: z.string().trim().min(1, { message: "Description is required" }),
  agent_type: z.boolean().default(false),
});

export type EditAgentForm = z.infer<typeof editAgentSchema>;

export const editAgentDefaultValue: EditAgentForm = {
  name: "",
  description: "",
  agent_type: false,
};

